module.exports = __webpack_public_path__ + "img/FGr_Ölschaden_B.e82efa7c.svg";